import { css } from '@fable/theme'
import { StatsProfileBoxInfo } from './StatsProfileBoxInfo'
import { CompChildren } from '@fable/types'
import { useStats } from '../../../lib/ctx/stats'
import { useStatsTheme } from '../../../theme/ctx'

export interface BoxTextProps {
  top: string
  main?: string | number
  bottom?: string | CompChildren
  unit?: string
  hideInfo?: boolean
  infoText?: string | CompChildren
  hideBottomLabel?: boolean
}

export const StatsProfileBoxText = ({
  top,
  main,
  bottom,
  unit,
  infoText,
  hideInfo = false,
  hideBottomLabel = false,
}: BoxTextProps) => {
  const [yearStatus, year, isSelfView] = useStats((s) => [
    s.yearStatus,
    s.year,
    s.isSelfView,
  ])
  const theme = useStatsTheme((s) => s.theme)
  const isCurrent = yearStatus === 'current'

  const getBottomText = () => {
    if (bottom) return bottom

    return (
      <span
        className={css`
          display: flex;
          gap: 3px;
        `}
      >
        {unit}
        <span
          className={css`
            color: ${theme.colors.section.textSecondary};
          `}
        >
          {isCurrent ? 'so far this year' : `in ${year}`}
        </span>
      </span>
    )
  }

  return (
    <h3
      className={css`
        font-size: 12px;
        line-height: 16px;
        letter-spacing: -0.2px;
        color: ${theme.colors.section.text};
        font-weight: 500;
        display: flex;
        flex-direction: column;
      `}
    >
      <span>{top}</span>
      <span
        className={css`
          font-family: 'Heldane Display', serif;
          font-size: 32px;
          line-height: 28px;
          letter-spacing: -0.5px;
          font-weight: 700;
          color: ${theme.colors.primary};
          transition: color ease-in-out 0.6s;
          will-change: color;
        `}
      >
        {main || 0}
      </span>
      {hideBottomLabel ? null : (
        <span
          className={css`
            margin-top: 2px;
            display: flex;
            align-items: center;
            gap: 3px;
          `}
        >
          {getBottomText()}
          {hideInfo || !isSelfView ? null : (
            <StatsProfileBoxInfo text={infoText} />
          )}
        </span>
      )}
    </h3>
  )
}
